module.exports = __webpack_public_path__ + "../static/img/be.88938092.png";